export { BvlTextareaComponent as BvlTextarea } from './textarea.component';
export { BvlTextareaModule } from './textarea.module';
